import { Logger, SystemEvent, SystemEventLevel } from 'bernie-logger';

export default class AffiliateHubLogger implements Logger {
  private logger: Logger;

  constructor(logger: Logger) {
    this.logger = logger;
  }

  private log = (level: SystemEventLevel, event: string, args: any[]) => {
    this.logEvent(new SystemEvent(level, event), ...args);
  };

  public logEvent(systemEvent: SystemEvent, ...args: any[]): void {
    this.logger.logEvent(systemEvent, ...args);
  }

  public critical = (event, ...args: any[]) => {
    this.log(SystemEventLevel.CRITICAL, event, args);
  };

  public error = (event: string, ...args: any[]) => {
    this.log(SystemEventLevel.ERROR, event, args);
  };

  public warn = (event, ...args: any[]) => {
    this.log(SystemEventLevel.WARN, event, args);
  };

  public info = (event, ...args: any[]) => {
    this.log(SystemEventLevel.INFO, event, args);
  };
}
